import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-annotation', 'open', 'Ava annotatsioon');
Labels.set('ui-annotation', 'close', 'Sulge annotatsioon');
